import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
  uploadImage,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const EditCulturalPlace = () => {
  const [formData, setFormData] = useState({});
  const [provOptions, setProvOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [cover, setCover] = useState(null);

  const breadcrumb = {
    current_section: "Luoghi della Cultura",
    sections: [
      { name: "Home", route_name: null, params: [] },
      { name: "Luoghi", route_name: null, params: [] },
      { name: "Modifica", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchCulturalPlace = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseURL
          }/ldc/ldcgetbyid?id=${window.location.pathname.split("/").pop()}`,
          fetchOptions
        );
        const result = await response.json();
        setFormData(result.return.ldc[0]);
      } catch (error) {
        console.error(error);
      }
    };
    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();
        setProvOptions(
          convertIntoSelect2Options(result.provincie, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchCulturalPlace();
    fetchProvs();
  }, []);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${formData.idprovincia}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchCities();
  }, [formData.idprovincia]);

  const handleNameChange = (e) => {
    setFormData((prevData) => ({ ...prevData, nome: e.target.value }));
  };

  const handleCodeChange = (e) => {
    setFormData((prevData) => ({ ...prevData, codice: e.target.value }));
  };

  const handleProvinceChange = (e) => {
    setFormData((prevData) => ({ ...prevData, idprovincia: e?.value }));

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/comuni?idprov=${e?.value}`,
          fetchOptions
        );
        const result = await response.json();
        setCityOptions(convertIntoSelect2Options(result.comuni, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchCities();
  };

  const handleCityChange = (e) => {
    setFormData((prevData) => ({ ...prevData, idcomune: e?.value }));
  };

  const handleLongChange = (e) => {
    setFormData((prevData) => ({ ...prevData, longitude: e.target.value }));
  };

  const handleLatChange = (e) => {
    setFormData((prevData) => ({ ...prevData, latitude: e.target.value }));
  };

  const handleAddressChange = (e) => {
    setFormData((prevData) => ({ ...prevData, indirizzo: e.target.value }));
  };

  const handleDescriptionChange = (e) => {
    setFormData((prevData) => ({ ...prevData, descrizione: e.target.value }));
  };

  const handleCoverChange = (e) => {
    const file = e.target.files[0];
    setCover(file);
  };

  const handleUpdateCover = () => {
    if (!cover) {
      alert("Seleziona un'immagine da caricare.");
      return;
    }
    const file = cover;

    if (file) {
      uploadImage(file)
        .then(async (url) => {
          const fetchOptions = getFetchOptions(
            "application/json",
            { ldcId: formData.id, importLink: url },
            "PUT"
          );
          const response = await fetch(
            `${axios.defaults.baseBFFUrl}/fe/updateImportImageLink`,
            fetchOptions
          );
          const result = await response.json();
          if (result.error) {
            alert("Errore durante il caricamento dell'immagine. Riprova.");
            return;
          }

          alert("Immagine del luogo aggiornata con successo!");
          window.location = "/culturalPlaces";
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
        });
    }
  };

  const handleSave = async () => {
    if (!formData.nome) {
      alert("Il campo 'Nome del luogo' è obbligatorio.");
      return;
    }
    if (!formData.codice) {
      alert("Il campo 'Codice Luogo' è obbligatorio.");
      return;
    }
    if (!formData.idprovincia) {
      alert("Il campo 'Provincia' è obbligatorio.");
      return;
    }
    if (!formData.idcomune) {
      alert("Il campo 'Comune' è obbligatorio.");
      return;
    }
    if (!formData.longitude) {
      alert("Il campo 'Longitudine' è obbligatorio.");
      return;
    }
    if (!formData.latitude) {
      alert("Il campo 'Latitudine' è obbligatorio.");
      return;
    }
    if (!formData.indirizzo) {
      alert("Il campo 'Indirizzo' è obbligatorio.");
      return;
    }

    if (!formData.descrizione) {
      formData.descrizione = "";
    }

    const fetchOptions = getFetchOptions(
      "application/json",
      {
        ldcId: formData.id,
        ldcData: formData,
      },
      "PUT"
    );
    const response = await fetch(
      `${axios.defaults.baseBFFUrl}/fe/updateLDC`,
      fetchOptions
    );

    const result = await response.json();
    if (!result.return) {
      console.error("Error updating cultural place:", result);
      alert(
        "Errore durante l'aggiornamento del luogo della cultura. Riprova più tardi."
      );
      return;
    }

    window.location = "/culturalPlaces";
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a href="/culturalPlaces">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista luoghi
        </button>
      </a>

      {/* Cultural Place Details */}
      <div className="card custom-card">
        <div className="card-header">Dati generali</div>
        <div className="card-body">
          {/* Name of the Place */}
          <div className="row mb-3">
            <div className="col">
              <label htmlFor="nome">Nome del luogo</label>
              <input
                id="nome"
                name="nome"
                className="form-control"
                value={formData.nome || ""}
                onChange={handleNameChange}
              />
            </div>
            {/* <div className="col">
              <label htmlFor="codice">Codice Luogo</label>
              <input
                id="codice"
                name="codice"
                className="form-control disabled"
                value={formData.codice || ""}
                onChange={handleCodeChange}
                readOnly
                disabled
              />
            </div> */}
          </div>

          <div className="row mb-3">
            <div className="col">
              <label htmlFor="province">Provincia</label>
              <Select
                options={provOptions}
                id="province"
                name="province"
                value={provOptions.filter(function (option) {
                  return option.value === Number(formData.idprovincia);
                })}
                onChange={handleProvinceChange}
                classNames={"form-control"}
                placeholder="Scegli provincia..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col">
              <label htmlFor="city">Comune</label>
              <Select
                options={cityOptions}
                id="city"
                name="city"
                value={cityOptions?.filter(function (option) {
                  return option.value === Number(formData.idcomune);
                })}
                onChange={handleCityChange}
                classNames={"form-control"}
                placeholder="Scegli comune..."
                isSearchable
                isClearable
              />
            </div>
          </div>

          {/* Longitude, Latitude, and Address */}
          <div className="row mb-3">
            <div className="col-4 col-lg-2">
              <label htmlFor="longitudine">Longitudine</label>
              <input
                id="longitudine"
                name="longitudine"
                className="form-control"
                value={formData.longitude || ""}
                onChange={handleLongChange}
              />
            </div>
            <div className="col-4 col-lg-2">
              <label htmlFor="latitudine">Latitudine</label>
              <input
                id="latitudine"
                name="latitudine"
                label="Latitudine"
                className="form-control"
                value={formData.latitude || ""}
                onChange={handleLatChange}
              />
            </div>
            <div className="col-4 col-lg-8">
              <label htmlFor="indirizzo">Indirizzo</label>
              <input
                id="indirizzo"
                name="indirizzo"
                label="Indirizzo"
                className="form-control"
                value={formData.indirizzo || ""}
                onChange={handleAddressChange}
              />
            </div>
          </div>

          {/* Short Description */}
          <div className="row mb-3">
            <div className="col-12">
              <label htmlFor="smallDesc">Breve descrizione</label>
              <textarea
                id="descrizione"
                name="descrizione"
                className="form-control w-100"
                value={formData.descrizione || ""}
                onChange={handleDescriptionChange}
              >
                {formData.descrizione || ""}
              </textarea>
            </div>
          </div>

          {/* Save Button */}
          <div className="saveButtonContainer">
            <button
              id="savePlaceBtn"
              name="savePlaceBtn"
              className="btn btn-success saveButton"
              type="button"
              onClick={handleSave}
            >
              &nbsp;Salva
            </button>
          </div>
        </div>
      </div>

      {/* Images LDCs */}
      <div className="card custom-card">
        <div className="card-header">Aggiornamento immagine cover</div>
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-12">
              <input
                id="cover"
                name="cover"
                type="file"
                className="form-control"
                accept=".jpg, .jpeg, .png"
                onChange={handleCoverChange}
              />
            </div>
          </div>

          {/* Save Button */}
          <div className="saveButtonContainer">
            <button
              id="saveCoverBtn"
              name="saveCoverBtn"
              className="btn btn-success saveButton"
              type="button"
              onClick={handleUpdateCover}
            >
              &nbsp;Salva
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCulturalPlace;
